import React from "react";

export const Paragraph = ({ explain }) => {
  return (
    <p className=" leading-loose text-slate-300 font-light text-[15px] lg:text-lg">
      {explain}
    </p>
  );
};
